import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { AuthContext, useAuth } from "../../context/AuthContext";
import styled from 'styled-components';
import toast from 'react-hot-toast';
import { ssoFinalize } from "../../utils/ssoFinalize";

const Container = styled.div`
 display: flex;
 padding-top: 8rem;
 flex-direction: column;
 align-items: center;
 justify-content: center;
`;

const Card = styled.div`
 
width: 100%;
width:400px;
max-width:850px;
 background: white;
 border-radius: 8px;
 box-shadow: 1px 2px 15px -5px rgb(0 0 0 / 1.4);
`;

const CardHeader = styled.div`
 padding: 24px;
 text-align: center;
`;

const CardTitle = styled.h2`
 font-size: 24px;
 font-weight: 600;
 margin-bottom: 8px;
`;

const CardDescription = styled.p`
 color: #666;
 font-size: 14px;
`;


const Form = styled.form`
 padding: 24px;
 display: flex;
 flex-direction: column;
 gap: 16px;
`;

const InputGroup = styled.div`
 display: flex;
 flex-direction: column;
 gap: 8px;
`;

const Label = styled.label`
 font-size: 14px;
 font-weight: 500;
`;

const Input = styled.input`
 padding: 8px;
 border: 1px solid #e2e8f0;
 border-radius: 6px;
 width: calc(100% - 16px);
`;

const Select = styled.select`
 padding: 8px;
 border: 1px solid #e2e8f0;
 border-radius: 6px;
 width: 100%;
`;

const RadioGroup = styled.div`
 display: flex;
 gap: 16px;
 align-items: center;
`;

const RadioLabel = styled.label`
 display: flex;
 align-items: center;
 gap: 4px;
 cursor: pointer;
`;

const BirthGroup = styled.div`
 display: grid;
 grid-template-columns: repeat(3, 1fr);
 gap: 8px;
`;

const Button = styled.button`
 width: 100%;
 padding: 8px;
 background: #000;
 color: white;
 border: none;
 border-radius: 6px;
 cursor: pointer;
 font-weight: 500;
 
 &:disabled {
   opacity: 0.7;
 }
`;

function Login() {
   const [userId, setUserId] = useState("");
   const [password, setPassword] = useState("");
   const [message, setMessage] = useState("");
   const [isLoading, setIsLoading] = useState(false);
   const navigate = useNavigate();
   const { login } = useAuth();

   const handleLoginClick = async () => {
       setIsLoading(true);
       try {
           const response = await fetch('/request/login', {
               method: 'POST',
               headers: { 'Content-Type': 'application/json' },
               body: JSON.stringify({ user_id: userId, user_pwd: password }),
               credentials: 'include'
           });

           if (response.ok) {
               const userData = await response.json();
               login(userData);
               navigate('/');
           } else {
               toast.error(response.status === 401
                   ? "아이디 또는 비밀번호가 잘못되었습니다."
                   : "로그인에 실패하였습니다. 다시 시도해주세요.");
           }
       } catch (error) {
           setMessage("로그인 요청 중 문제가 발생했습니다.");
       } finally {
           setIsLoading(false);
       }
   };

   return (
       <Container>
           <Card>
               <CardHeader>
                   <CardTitle>AntsNest</CardTitle>
                   <CardDescription> WBS 시스템</CardDescription>
               </CardHeader>
               <Form onSubmit={(e) => { e.preventDefault(); handleLoginClick(); }}>
                   {message && <p style={{color: 'red', textAlign: 'center'}}>{message}</p>}
                   <InputGroup>
                       <Label htmlFor="id">아이디</Label>
                       <Input
                           id="id"
                           type="text"
                           value={userId}
                           onChange={(e) => setUserId(e.target.value)}
                           required
                       />
                   </InputGroup>
                   <InputGroup>
                       <Label htmlFor="password">비밀번호</Label>
                       <Input
                           id="password"
                           type="password"
                           value={password}
                           onChange={(e) => setPassword(e.target.value)}
                           required
                       />
                   </InputGroup>
                   <Button type="submit" disabled={isLoading}>
                       {isLoading ? "로그인 중..." : "로그인"}
                   </Button>
                   <div style={{display: 'flex', justifyContent: 'space-between'}}>
                       <Link to="/forgot-password" style={{color: '#666', textDecoration: 'none'}}>
                           비밀번호 찾기
                       </Link>
                       <a
                         href="#"
                         style={{color: '#666', textDecoration: 'none', cursor: 'pointer'}}
                         onClick={(e) => {
                           e.preventDefault();
                           const parentOrigin = window.location.origin;
                           const url = `https://talk.antsnest.co.kr/popup/register?parentOrigin=${encodeURIComponent(parentOrigin)}`;
                           const popup = window.open(url, 'antsTalkRegister', 'width=480,height=720,resizable=yes,scrollbars=yes');
                           const messageHandler = async (event) => {
                             if (!['https://talk.antsnest.co.kr', 'http://localhost:3000'].includes(event.origin)) return;
                             if (event.data?.type !== 'SSO_REGISTER_SUCCESS' && event.data?.type !== 'SSO_LOGIN_SUCCESS') return;
                             window.removeEventListener('message', messageHandler);
                             try { popup && popup.close(); } catch (_) {}
                             await ssoFinalize(event.data, login);
                           };
                           window.addEventListener('message', messageHandler);
                         }}
                       >
                           회원가입
                       </a>
                   </div>
               </Form>
           </Card>
       </Container>
   );
}

export default Login ;